const translations = {
  en: {
    header: {
      title: 'Part Plan/Zone Certificate',
      subtitle: 'Government of Maharashtra',
      applicantLogin: 'Applicant Login',
      officeLogin: 'Office Login',
      home: 'HOME',
      faq: 'F&Q',
      contact: 'CONTACT US',
      userGuide: 'User Guide'
    },
    home: {
      getCertificate: 'Get Part Plan/Zone Certificate',
      description: 'Access and manage your zoning certificates through our secure online portal',
      applicantLogin: 'Applicant Login',
      applicantRegister: 'Applicant Registration',
      faqTitle: 'Frequently Asked Questions',
      faqSubtitle: 'Find answers to common questions about our services',
      faq1: {
        question: 'How do I apply for a Zone Certificate?',
        stepsTitle: 'To apply for a Zone Certificate, follow these steps:',
        step1: 'Register as an applicant on our portal',
        step2: 'Login to your account',
        step3: 'Fill out the required application form',
        step4: 'Upload necessary documents',
        step5: 'Submit your application'
      },
      faq2: {
        question: 'What documents are required for registration?',
        documentsTitle: 'Required documents include:',
        document1: 'Valid ID proof',
        document2: 'Address proof',
        document3: 'Property documents',
        document4: 'Recent photographs'
      },
      faq3: {
        question: 'How long does the certification process take?',
        answer: 'The typical processing time is 7-10 working days after submission of all required documents. Complex cases may take longer.'
      },
      faq4: {
        question: 'What is the validity period of the certificate?',
        answer: 'The Zone Certificate is valid for a period of 1 year from the date of issuance. After expiry, you will need to apply for renewal.'
      }
    },
    contact: {
      title: 'Contact Us',
      address: 'Address',
      email: 'Email',
      phone: 'Phone',
      akurdiOffice: {
        title: 'Akurdi Office',
        address: {
          line1: 'Survey No. 152-153,',
          line2: 'Near Akurdi Railway Station,',
          line3: 'Udyog Bhavan, Akurdi,',
          line4: 'Pune - 411067'
        }
      },
      adminOffice: {
        title: 'Administrative Office',
        address: {
          line1: 'New Administrative Building,',
          line2: 'Near Akurdi Railway Station',
          line3: 'Akurdi, Pune - 411044'
        }
      },
      otherDetails: {
        title: 'Other Details',
        telephone: 'Telephone Directory',
        telephoneText: 'Available on Request',
        hours: 'Office Hours',
        hoursText: '10:00 AM to 6:00 PM',
        weeklyOff: 'Weekly Off',
        weeklyOffText: 'Saturday and Sunday'
      },
      directory: {
        title: 'Directory of Officials',
        srNo: 'Sr. No.',
        officerName: 'Officer Name',
        designation: 'Designation',
        department: 'Department',
        phone: 'Phone No.',
        email: 'Email ID',
        officers: {
          officer1: {
            name: 'Shri Yogesh Mhase(I.A.S.)',
            designation: 'Metropolitan Commissioner CEO'
          },
          officer2: {
            designation: 'Personal Assistant (PA) of Metropolitan Commissioner'
          },
          officer3: {
            name: 'Shri. Dipak Singla',
            designation: 'Additional Metropolitan Commissioner'
          },
          officer4: {
            name: 'Smt. Padamshree Umesh Taldekar',
            designation: 'Financial Controller',
            department: 'Accounts and Finance Department'
          },
          officer5: {
            name: 'Shri. Sunil Pandhare',
            designation: 'Joint Commissioner',
            department: 'Admin Department'
          },
          officer6: {
            name: 'Smt. Snehal Barge',
            designation: 'Joint Commissioner',
            department: 'Land and Estate Department'
          },
          officer7: {
            name: 'Shri. Sunil Marale',
            designation: 'Metropolitan Planner',
            department: 'Building Permission Department'
          }
        }
      }
    },

    officeLogin: {
      title: 'Office Login',
      emailLabel: 'Office Email',
      emailPlaceholder: 'Enter your office email',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      loginButton: 'Login',
      cancelButton: 'Cancel',
      loggingIn: 'Logging in...',
      forgotPassword: 'Forgot your password?',
      closeButton: 'Close login form',
      successMessage: 'Login successful! Redirecting...',
      errors: {
        usernameRequired: 'Username is required',
        passwordRequired: 'Password is required',
        passwordLength: 'Password must be at least 6 characters',
        loginFailed: 'Login failed. Please try again.',
        invalidCredentials: 'Invalid credentials. Please try again.'
      }
    },

    
      stats: {
        "title": "Our Coverage",
        "divisions": "Divisions",
        "districts": "Districts",
        "talukas": "Talukas",
        "village": "Villages"
      },
    

    registration: {
      title: 'Create Your Account',
      tabLogin: 'Login',
      tabRegister: 'Register',
      closeButton: 'Close registration form',
      personalInfo: 'Personal Information',
      addressInfo: 'Address Information',
      security: 'Security',
      firstName: 'First Name',
      firstNamePlaceholder: 'First name',
      middleName: 'Middle Name',
      middleNamePlaceholder: 'Middle name',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Last name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      mobile: 'Mobile',
      mobilePlaceholder: '10-digit number',
      address: 'Address',
      addressPlaceholder: 'Full address',
      division: 'Division',
      selectDivision: 'Select Division',
      district: 'District',
      selectDistrict: 'Select District',
      taluka: 'Taluka',
      selectTaluka: 'Select Taluka',
      village: 'Village',
      villagePlaceholder: 'Enter village name',
      password: 'Password',
      passwordPlaceholder: 'At least 8 characters',
      passwordHint: 'Include uppercase, lowercase, number, and special character',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Re-enter password',
      registerButton: 'Register',
      resetButton: 'Reset',
      registering: 'Registering...',
      alreadyHaveAccount: 'Already have an account?',
      signIn: 'Sign in',
      successTitle: 'Success!',
      errorTitle: 'Error',
      successMessage: 'Registration successful! You can now login.',
      proceedToLogin: 'Proceed to Login',
      tryAgain: 'Try Again',
      locations: {
        amravati: 'Amravati',
        akola: 'Akola',
        akot: 'Akot',
        balapur: 'Balapur',
        pune: 'Pune',
        solapur: 'Solapur',
        solapurSouth: 'Solapur South'
      },
      errors: {
        firstNameRequired: 'First name is required',
        lastNameRequired: 'Last name is required',
        emailRequired: 'Email is required',
        validEmail: 'Please enter a valid email',
        mobileRequired: 'Mobile number is required',
        mobileDigits: 'Mobile must be 10 digits',
        addressRequired: 'Address is required',
        divisionRequired: 'Please select division',
        districtRequired: 'Please select district',
        talukaRequired: 'Please select taluka',
        villageRequired: 'Please enter village',
        passwordRequired: 'Password is required',
        passwordLength: 'Password must be at least 8 characters',
        passwordWeak: 'Password is too weak',
        confirmPasswordRequired: 'Please confirm password',
        passwordMismatch: 'Passwords do not match',
        registrationFailed: 'Registration failed. Please try again.',
        registrationIncomplete: 'Registration could not be completed.'
      }
    },


    login: {
      title: 'Applicant Login',
      tabLogin: 'Login',
      tabRegister: 'Register',
      closeButton: 'Close login form',
      emailLabel: 'Email',
      emailPlaceholder: 'your@email.com',
      passwordLabel: 'Password',
      passwordPlaceholder: '••••••••',
      loginButton: 'Login',
      cancelButton: 'Cancel',
      loggingIn: 'Logging in...',
      forgotPassword: 'Forgot your password?',
      successMessage: 'Login successful! Redirecting...',
      errors: {
        usernameRequired: 'Username is required',
        validEmail: 'Please enter a valid email',
        passwordRequired: 'Password is required',
        passwordLength: 'Password must be at least 6 characters',
        loginFailed: 'Login failed. Please try again.',
        invalidCredentials: 'Invalid credentials. Please try again.'
      }
    },


  },
  mr: {
    header: {
      title: 'पार्ट प्लान/झोन प्रमाणपत्र',
      subtitle: 'महाराष्ट्र शासन',
      applicantLogin: 'अर्जदार लॉगिन',
      officeLogin: 'कार्यालय लॉगिन',
      home: 'मुख्यपृष्ठ',
      faq: 'सामान्य प्रश्न',
      contact: 'संपर्क करा',
      userGuide: 'वापरकर्ता मार्गदर्शक'
    },
    home: {
      getCertificate: 'पार्ट प्लान/झोन प्रमाणपत्र मिळवा',
      description: 'आमच्या सुरक्षित ऑनलाइन पोर्टलद्वारे आपल्या झोनिंग प्रमाणपत्रांमध्ये प्रवेश करा आणि व्यवस्थापित करा',
      applicantLogin: 'अर्जदार लॉगिन',
      applicantRegister: 'अर्जदार नोंदणी',
      faqTitle: 'नेहमी विचारले जाणारे प्रश्न',
      faqSubtitle: 'आमच्या सेवांबद्दल सामान्य प्रश्नांची उत्तरे शोधा',
      faq1: {
        question: 'झोन प्रमाणपत्रासाठी मी अर्ज कसा करू?',
        stepsTitle: 'झोन प्रमाणपत्रासाठी अर्ज करण्यासाठी या चरणांचे अनुसरण करा:',
        step1: 'आमच्या पोर्टलवर अर्जदार म्हणून नोंदणी करा',
        step2: 'तुमच्या खात्यात लॉगिन करा',
        step3: 'आवश्यक अर्ज फॉर्म भरा',
        step4: 'आवश्यक कागदपत्रे अपलोड करा',
        step5: 'तुमचा अर्ज सबमिट करा'
      },
      faq2: {
        question: 'नोंदणीसाठी कोणती कागदपत्रे आवश्यक आहेत?',
        documentsTitle: 'आवश्यक कागदपत्रांमध्ये हे समाविष्ट आहे:',
        document1: 'वैध ओळखपत्र',
        document2: 'पत्ता पुरावा',
        document3: 'मालमत्ता कागदपत्रे',
        document4: 'अलीकडील फोटो'
      },
      faq3: {
        question: 'प्रमाणपत्र प्रक्रियेस किती वेळ लागतो?',
        answer: 'सर्व आवश्यक कागदपत्रे सबमिट केल्यानंतर सामान्य प्रक्रिया वेळ 7-10 कामकाजाचे दिवस असते. गुंतागुंतीच्या केससाठी अधिक वेळ लागू शकतो.'
      },
      faq4: {
        question: 'प्रमाणपत्राचा वैधता कालावधी किती आहे?',
        answer: 'झोन प्रमाणपत्र जारी केल्याच्या तारखेपासून 1 वर्षाच्या कालावधीसाठी वैध आहे. कालबाह्य झाल्यानंतर, तुम्हाला नूतनीकरणासाठी अर्ज करावा लागेल.'
      }
    },
    contact: {
      title: 'संपर्क करा',
      address: 'पत्ता',
      email: 'ईमेल',
      phone: 'फोन',
      akurdiOffice: {
        title: 'अकुर्डी कार्यालय',
        address: {
          line1: 'सर्व्हे नंबर १५२-१५३,',
          line2: 'अकुर्डी रेल्वे स्टेशन जवळ,',
          line3: 'उद्योग भवन, अकुर्डी,',
          line4: 'पुणे - ४११०६७'
        }
      },
      adminOffice: {
        title: 'प्रशासकीय कार्यालय',
        address: {
          line1: 'नवीन प्रशासकीय इमारत,',
          line2: 'अकुर्डी रेल्वे स्टेशन जवळ',
          line3: 'अकुर्डी, पुणे - ४११०४४'
        }
      },
      otherDetails: {
        title: 'इतर तपशील',
        telephone: 'टेलिफोन डिरेक्टरी',
        telephoneText: 'विनंतीवर उपलब्ध',
        hours: 'कार्यालयीन वेळ',
        hoursText: 'सकाळी १० ते संध्याकाळी ६',
        weeklyOff: 'साप्ताहिक सुट्टी',
        weeklyOffText: 'शनिवार व रविवार'
      },
      directory: {
        title: 'अधिकाऱ्यांची यादी',
        srNo: 'क्र.',
        officerName: 'अधिकाऱ्याचे नाव',
        designation: 'पदनाम',
        department: 'विभाग',
        phone: 'फोन नंबर',
        email: 'ईमेल आयडी',
        officers: {
          officer1: {
            name: 'श्री योगेश म्हासे (आय.ए.एस.)',
            designation: 'महानगर आयुक्त सीईओ'
          },
          officer2: {
            designation: 'महानगर आयुक्ताचे वैयक्तिक सहाय्यक (PA)'
          },
          officer3: {
            name: 'श्री दीपक सिंगला',
            designation: 'अतिरिक्त महानगर आयुक्त'
          },
          officer4: {
            name: 'सौ. पद्मश्री उमेश ताळदेकर',
            designation: 'वित्त नियंत्रक',
            department: 'लेखा आणि वित्त विभाग'
          },
          officer5: {
            name: 'श्री सुनील पांढरे',
            designation: 'संयुक्त आयुक्त',
            department: 'प्रशासन विभाग'
          },
          officer6: {
            name: 'सौ. स्नेहल बर्गे',
            designation: 'संयुक्त आयुक्त',
            department: 'जमीन आणि एस्टेट विभाग'
          },
          officer7: {
            name: 'श्री सुनील मराळे',
            designation: 'महानगर नियोजक',
            department: 'इमारत परवाना विभाग'
          }
        }
      }
    },

    officeLogin: {
      title: 'कार्यालय लॉगिन',
      emailLabel: 'कार्यालयीन ईमेल',
      emailPlaceholder: 'तुमचा कार्यालयीन ईमेल टाका',
      passwordLabel: 'पासवर्ड',
      passwordPlaceholder: 'तुमचा पासवर्ड टाका',
      loginButton: 'लॉगिन',
      cancelButton: 'रद्द करा',
      loggingIn: 'लॉगिन होत आहे...',
      forgotPassword: 'पासवर्ड विसरलात?',
      closeButton: 'लॉगिन फॉर्म बंद करा',
      successMessage: 'लॉगिन यशस्वी! पुनर्निर्देशित करत आहे...',
      errors: {
        usernameRequired: 'वापरकर्तानाव आवश्यक आहे',
        passwordRequired: 'पासवर्ड आवश्यक आहे',
        passwordLength: 'पासवर्ड किमान ६ वर्णांचा असावा',
        loginFailed: 'लॉगिन अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
        invalidCredentials: 'अवैध प्रमाणपत्रे. कृपया पुन्हा प्रयत्न करा.'
      }
    },
    
    stats: {
    "title": "आमचे कव्हरेज",
    "divisions": "विभाग",
    "districts": "जिल्हे",
    "talukas": "तालुके",
    "village": "गावे"
  },
    registration: {
      title: 'तुमचे खाते तयार करा',
      tabLogin: 'लॉगिन',
      tabRegister: 'नोंदणी',
      closeButton: 'नोंदणी फॉर्म बंद करा',
      personalInfo: 'वैयक्तिक माहिती',
      addressInfo: 'पत्ता माहिती',
      security: 'सुरक्षा',
      firstName: 'पहिले नाव',
      firstNamePlaceholder: 'पहिले नाव',
      middleName: 'मधले नाव',
      middleNamePlaceholder: 'मधले नाव',
      lastName: 'आडनाव',
      lastNamePlaceholder: 'आडनाव',
      email: 'ईमेल',
      emailPlaceholder: 'तुमचा@ईमेल.कॉम',
      mobile: 'मोबाइल',
      mobilePlaceholder: '10-अंकी क्रमांक',
      address: 'पत्ता',
      addressPlaceholder: 'संपूर्ण पत्ता',
      division: 'विभाग',
      selectDivision: 'विभाग निवडा',
      district: 'जिल्हा',
      selectDistrict: 'जिल्हा निवडा',
      taluka: 'तालुका',
      selectTaluka: 'तालुका निवडा',
      village: 'गाव',
      villagePlaceholder: 'गावाचे नाव टाका',
      password: 'पासवर्ड',
      passwordPlaceholder: 'किमान 8 वर्ण',
      passwordHint: 'मोठ्या अक्षर, लहान अक्षर, संख्या आणि विशेष वर्ण समाविष्ट करा',
      confirmPassword: 'पासवर्ड पुष्टी करा',
      confirmPasswordPlaceholder: 'पासवर्ड पुन्हा टाका',
      registerButton: 'नोंदणी करा',
      resetButton: 'रद्द करा',
      registering: 'नोंदणी होत आहे...',
      alreadyHaveAccount: 'आधीपासून खाते आहे?',
      signIn: 'साइन इन करा',
      successTitle: 'यशस्वी!',
      errorTitle: 'त्रुटी',
      successMessage: 'नोंदणी यशस्वी! आता तुम्ही लॉगिन करू शकता.',
      proceedToLogin: 'लॉगिन करा',
      tryAgain: 'पुन्हा प्रयत्न करा',
      locations: {

          // Akola District
    Akola: "अकोला",
    Akot: "अकोट",
    Balapur: "बाळापूर",
    Barshitakli: "बार्शीटाकली",
    Murtijapur: "मुर्तिजापूर",
    Patur: "पातूर",
    Telhara: "तेळहारा",
    
 
      },
      errors: {
        firstNameRequired: 'पहिले नाव आवश्यक आहे',
        lastNameRequired: 'आडनाव आवश्यक आहे',
        emailRequired: 'ईमेल आवश्यक आहे',
        validEmail: 'कृपया वैध ईमेल टाका',
        mobileRequired: 'मोबाइल क्रमांक आवश्यक आहे',
        mobileDigits: 'मोबाइल 10 अंकी असावा',
        addressRequired: 'पत्ता आवश्यक आहे',
        divisionRequired: 'कृपया विभाग निवडा',
        districtRequired: 'कृपया जिल्हा निवडा',
        talukaRequired: 'कृपया तालुका निवडा',
        villageRequired: 'कृपया गाव टाका',
        passwordRequired: 'पासवर्ड आवश्यक आहे',
        passwordLength: 'पासवर्ड किमान 8 वर्णांचा असावा',
        passwordWeak: 'पासवर्ड खूप कमकुवत आहे',
        confirmPasswordRequired: 'कृपया पासवर्ड पुष्टी करा',
        passwordMismatch: 'पासवर्ड जुळत नाही',
        registrationFailed: 'नोंदणी अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
        registrationIncomplete: 'नोंदणी पूर्ण होऊ शकली नाही.'
      }
    },


    login: {
      title: 'अर्जदार लॉगिन',
      tabLogin: 'लॉगिन',
      tabRegister: 'नोंदणी',
      closeButton: 'लॉगिन फॉर्म बंद करा',
      emailLabel: 'ईमेल',
      emailPlaceholder: 'तुमचा@ईमेल.कॉम',
      passwordLabel: 'पासवर्ड',
      passwordPlaceholder: '••••••••',
      loginButton: 'लॉगिन',
      cancelButton: 'रद्द करा',
      loggingIn: 'लॉगिन होत आहे...',
      forgotPassword: 'पासवर्ड विसरलात?',
      successMessage: 'लॉगिन यशस्वी! पुनर्निर्देशित करत आहे...',
      errors: {
        usernameRequired: 'वापरकर्तानाव आवश्यक आहे',
        validEmail: 'कृपया वैध ईमेल टाका',
        passwordRequired: 'पासवर्ड आवश्यक आहे',
        passwordLength: 'पासवर्ड किमान ६ वर्णांचा असावा',
        loginFailed: 'लॉगिन अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
        invalidCredentials: 'अवैध प्रमाणपत्रे. कृपया पुन्हा प्रयत्न करा.'
      }
    },


  }
};

let currentLanguage = 'en';

export const setLanguage = (lang) => {
  currentLanguage = lang;
  localStorage.setItem('preferredLanguage', lang);
};

export const getLanguage = () => currentLanguage;

export const t = (key) => {
  const keys = key.split('.');
  let value = translations[currentLanguage];

  for (const k of keys) {
    if (value && value[k] !== undefined) {
      value = value[k];
    } else {
      console.warn(`Translation not found for key: ${key}`);
      return key;
    }
  }

  return value;
};

// Initialize language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem('preferredLanguage');
if (savedLanguage) {
  currentLanguage = savedLanguage;
}